import store from "../store";

// check permission middleware
const isLogin = (to, from, next) => {
  // check user login
  console.log("check isLogin,", store.state.user.isLogin);
  if (!store.state.user.isLogin) {
    return next({
      path: "/checkLogin",
      query: { redirect: to.fullPath },
    });
  }

  return next();
};

const routes = [
  {
    path: "/checkLogin",
    name: "CheckLogin",
    component: () => import("../views/CheckLogin"),
    meta: { title: "檢查登入狀態" },
  },
  {
    path: "/oauth/signin",
    name: "authorize",
    component: () => import("../views/oauthSignin"),
    meta: { title: "oauth授權登入頁面" },
  },
  {
    path: "/oauth/authorize",
    name: "authorize",
    component: () => import("../views/oauthAuthorize"),
    meta: { title: "oauth授權確認頁面" },
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login"),
    meta: { title: "登入" },
  },
  {
    path: "/logout",
    name: "Logout",
    component: () => import("../views/Logout"),
    meta: { title: "登出" },
  },
  {
    isMain: true,
    path: "/",
    beforeEnter: isLogin,
    component: () => import("@/components/layouts/Main"),
    children: [
      {
        path: "/",
        name: "Gateway",
        component: () => import("../views/Gateway"),
        meta: {},
      },
      {
        subTab: "today",
        label: "病歷",
        path: "/today/record",
        name: "TodayRecord",
        component: () => import("../views/today/Record"),
        meta: {
          title: "今日看診 - 病歷",
          minPermissionRequired: ["DAILY_STATUS"],
        },
      },
      {
        subTab: "today",
        label: "掛號/報到",
        path: "/today/checkin",
        name: "TodayCheckIn",
        component: () => import("../views/today/CheckIn"),
        meta: {
          title: "今日看診 - 掛號/報到",
          minPermissionRequired: ["DAILY_STATUS"],
        },
      },
      {
        subTab: "today",
        label: "檢驗",
        path: "/today/exam",
        name: "TodayTodoExam",
        component: () => import("../views/today/Exam"),
        meta: {
          title: "今日看診 - 檢驗",
          minPermissionRequired: ["LAB_TASK_READ"],
        },
      },
      {
        subTab: "today",
        label: "藥局",
        path: "/today/dispense",
        name: "TodayTodoDispense",
        component: () => import("../views/today/Dispense"),
        meta: {
          title: "今日看診 - 藥局",
          minPermissionRequired: ["DRUG_TASK_READ"],
        },
      },
      {
        subTab: "today",
        label: "結帳",
        path: "/today/checkout",
        name: "TodayCheckout",
        component: () => import("../views/today/Checkout"),
        meta: {
          title: "今日看診 - 結帳",
          minPermissionRequired: ["BILLING_READ"],
        },
      },
      {
        subTab: "today",
        label: "審查", // 初診審查
        path: "/today/CheckData", 
        name: "TodayCheckData",
        // component: () => import("../views/today/CheckData"),
        component: () => import("../views/pets/PendingPets"),
        meta: {
          title: "今日看診 - 審查",
          // minPermissionRequired: ["BILLING_READ"],
        },
      },
      {
        subTab: "today",
        label: "預約審查",
        path: "/today/CheckBooking",
        name: "TodayCheckBooking",
        component: () => import("../views/today/CheckBooking"),
        meta: {
          title: "今日看診 - 預約審查",
        },
      },
      // {
      //   subTab: "schedule",
      //   label: "總覽",
      //   path: "/schedule/overview",
      //   name: "ScheduleOverview",
      //   component: () => import("../views/todaySchedule/Overview"),
      //   meta: {
      //     title: "今日看診 - 總覽",
      //     minPermissionRequired: ["DAILY_STATUS"],
      //   },
      // },
      // {
      //   subTab: "schedule",
      //   label: "候診",
      //   path: "/schedule/waiting",
      //   name: "ScheduleWaiting",
      //   component: () => import("../views/todaySchedule/Waiting"),
      //   meta: {
      //     title: "今日看診 - 後診名單",
      //     minPermissionRequired: ["WAITING_LIST"],
      //   },
      // },
      // {
      //   subTab: "schedule",
      //   label: "待辦",
      //   path: "/schedule/todo",
      //   name: "ScheduleTodo",
      //   component: () => import("../views/todaySchedule/Todo"),
      //   meta: {
      //     title: "今日看診 - 待辦事項",
      //     minPermissionRequired: ["DRUG_TASK_READ", "LAB_TASK_READ"],
      //   },
      // },
      // {
      //   subTab: "schedule",
      //   label: "結帳",
      //   path: "/schedule/checkout",
      //   name: "ScheduleCheckout",
      //   component: () => import("../views/todaySchedule/Checkout"),
      //   meta: {
      //     title: "今日看診 - 結帳",
      //     minPermissionRequired: ["BILLING_READ"],
      //   },
      // },
      {
        path: "/booking",
        name: "Booking",
        component: () => import("../views/Booking"),
        meta: {
          title: "預約管理 - 列表",
          minPermissionRequired: ["BOOKING_READ"],
        },
      },
      {
        path: "/record",
        name: "Record",
        component: () => import("../views/record/Index"),
        meta: {
          title: "病歷管理 - 列表",
          minPermissionRequired: ["RECORD_READ"],
        },
      },
      {
        subTab: "customer",
        label: "寵物",
        path: "/pets",
        name: "Pets",
        component: () => import("../views/pets/Index"),
        meta: {
          title: "寵物管理 - 列表",
          minPermissionRequired: ["PET_READ", "RECORD_READ"],
        },
      },
      {
        subTab: "customer",
        label: "飼主",
        path: "/users",
        name: "User",
        component: () => import("../views/users/Index"),
        meta: {
          title: "飼主管理 - 列表",
          minPermissionRequired: ["CUSTOMER_READ"],
        },
      },
      {
        path: "/user/:email",
        name: "UserDetail",
        component: () => import("../views/users/Detail"),
        meta: {
          title: "飼主管理 - 詳細資料",
          minPermissionRequired: ["CUSTOMER_READ"],
        },
      },
      {
        path: "/user/:clinicID/:email",
        name: "AllianceUserDetail",
        component: () => import("../views/users/AllianceDetail"),
        meta: {
          title: "飼主管理 - 詳細資料",
          minPermissionRequired: ["CUSTOMER_READ"],
        },
      },
      {
        subTab: "customer",
        label: "待審查寵物",
        path: "/pendingPets",
        name: "PendingPets",
        component: () => import("../views/pets/PendingPets"),
        meta: {
          title: "寵物管理 - 待審查寵物列表",
          minPermissionRequired: ["PET_READ", "RECORD_READ"],
        },
      },
      {
        path: "/petProfile/:petId/",
        name: "petProfile",
        component: () => import("../views/pets/PetProfile"),
        meta: {
          title: "病歷管理 - 寵物檔案",
          minPermissionRequired: ["PET_READ", "RECORD_READ"],
        },
      },
      {
        path: "/petProfile/:clinicID/:petId/",
        name: "AlliancePetProfile",
        component: () => import("../views/pets/AlliancePetProfile"),
        meta: {
          title: "病歷管理 - 寵物檔案",
          minPermissionRequired: ["PET_READ", "RECORD_READ"],
        },
      },
      {
        path: "/pet/:id/surgery/:rid",
        name: "SurgeryMonitor",
        component: () => import("../views/pets/SurgeryMonitor"),
        meta: {
          title: "寵物管理 - 手術紀錄",
          minPermissionRequired: ["RECORD_READ"],
        },
      },
      // {
      //   path: "/drug",
      //   name: "drug",
      //   component: () => import("../views/DrugManage"),
      //   meta: {
      //     title: "藥單管理 - 列表",
      //     minPermissionRequired: ["DRUG_TASK_READ"],
      //   },
      // },
      {
        subTab: "inHospital",
        label: "住院病歷",
        path: "/inHospital/active",
        name: "InHospitalActive",
        childRoutes: ["EditInHospital", "EditInHospitalVer2"],
        component: () => import("../views/inHospital/Active"),
        meta: {
          title: "住院管理 - 住院病歷",
          minPermissionRequired: ["RECORD_READ"],
        },
      },
      {
        subTab: "inHospital",
        label: "今日任務",
        path: "/inHospital/mission",
        name: "InHospitalMission",
        component: () => import("../views/inHospital/MissionSlot"),
        meta: {
          title: "住院管理 - 今日任務",
          minPermissionRequired: ["RECORD_READ"],
        },
      },
      {
        subTab: "inHospital",
        label: "歷史紀錄",
        path: "/inHospital/manage",
        name: "InHospitalManage",
        component: () => import("../views/inHospital/Manage"),
        meta: {
          title: "住院管理 - 歷史紀錄",
          minPermissionRequired: ["RECORD_READ"],
        },
      },
      {
        path: "/inHospital/edit/:inHospitalID",
        name: "EditInHospital",
        component: () => import("../views/inHospital/EditInHospital"),
        meta: {
          title: "住院管理 - 編輯住院",
          minPermissionRequired: ["RECORD_READ"],
        },
      },
      {
        path: "/inHospital/edit/v2/:inHospitalID",
        name: "EditInHospitalVer2",
        component: () => import("../views/inHospital/EditInHospitalVer2"),
        meta: {
          title: "住院管理 - 編輯住院",
          minPermissionRequired: ["RECORD_READ"],
        },
      },
      {
        subTab: "checkout",
        label: "帳單",
        path: "/checkout/accounting",
        name: "CheckoutAccounting",
        component: () => import("../views/checkout/AccountingManage"),
        meta: {
          title: "收銀台 - 帳單",
          minPermissionRequired: ["BILLING_READ"],
        },
      },
      {
        subTab: "checkout",
        label: "其他收支",
        path: "/checkout/other",
        name: "CheckoutOther",
        component: () => import("../views/checkout/OtherManage"),
        meta: {
          title: "收銀台 - 其他收支",
          minPermissionRequired: ["BILLING_READ", "BILLING_OTHERS"],
        },
      },
      {
        subTab: "checkout",
        label: "結算統計",
        path: "/checkout/stat",
        name: "CheckoutStat",
        component: () => import("../views/checkout/Statistic"),
        meta: {
          title: "收銀台 - 結算統計",
          minPermissionRequired: ["BILLING_READ_STAT"],
        },
      },
      {
        subTab: "checkout",
        label: "收銀台交班",
        path: "/checkout/handover",
        name: "CheckoutHandover",
        component: () => import("../views/checkout/Handover"),
        meta: {
          title: "收銀台 - 交班",
          minPermissionRequired: ["BILLING_READ", "BILLING_HANDOVER"],
        },
      },
      {
        subTab: "checkout",
        label: "儲值金",
        path: "/checkout/deposit",
        name: "CheckoutDeposit",
        component: () => import("../views/checkout/DepositManage"),
        meta: {
          title: "收銀台 - 儲值金",
          minPermissionRequired: ["BILLING_READ"],
        },
      },
      {
        subTab: "checkout",
        label: "廠商付款",
        path: "/checkout/payment",
        name: "CheckoutPayment",
        component: () => import("../views/checkout/Payment"),
        meta: {
          title: "收銀台 - 廠商付款",
          minPermissionRequired: ["PAYMENT_FORM_READ"],
        },
      },
      {
        subTab: "checkout",
        label: "業績分配",
        path: "/checkout/billBelongs",
        name: "CheckoutBillBelongs",
        component: () => import("../views/checkout/BillBelongs"),
        meta: {
          title: "收銀台 - 業績分配",
          minPermissionRequired: ["BILLING_DISTRIBUTION_READ"],
        },
      },
      {
        subTab: "inventory",
        label: "品項",
        path: "/inventory/product",
        name: "InventoryProduct",
        childRoutes: ["InventoryEditProduct"],
        component: () => import("../views/inventory/ProductList"),
        meta: {
          title: "進銷存 - 品項",
          minPermissionRequired: ["PRODUCT_READ"],
        },
      },
      {
        path: "/inventory/product/:id",
        name: "InventoryEditProduct",
        component: () => import("../views/inventory/EditProduct"),
        meta: {
          title: "進銷存 - 品項明細",
          minPermissionRequired: ["PRODUCT_READ"],
        },
      },
      {
        path: "/inventory/product/:id/stock",
        name: "InventoryControlledDrugStock",
        component: () => import("../views/inventory/CDrugStock"),
        meta: {
          title: "進銷存 - 管制藥庫存",
          minPermissionRequired: ["PRODUCT_READ"],
        },
      },
      {
        subTab: "inventory",
        label: "耗材組合",
        path: "/inventory/package",
        name: "InventoryPackage",
        component: () => import("../views/inventory/Package"),
        meta: {
          title: "進銷存 - 耗材組合",
          minPermissionRequired: ["PRODUCT_READ"],
        },
      },
      {
        subTab: "inventory",
        label: "供應商",
        path: "/inventory/supplier",
        name: "InventorySupplier",
        childRoutes: ["InventoryEditSupplier"],
        component: () => import("../views/inventory/Supplier"),
        meta: {
          title: "進銷存 - 供應商",
          minPermissionRequired: ["SUPPLIER_READ"],
        },
      },
      {
        path: "/inventory/editSupplier",
        name: "InventoryEditSupplier",
        component: () => import("../views/inventory/EditSupplier"),
        meta: {
          title: "進銷存 - 編輯供應商",
          minPermissionRequired: ["SUPPLIER_READ"],
        },
      },
      {
        subTab: "inventory",
        label: "庫存",
        path: "/inventory/manage",
        name: "InventoryManage",
        childRoutes: ["InventoryCheck"],
        component: () => import("../views/inventory/Manage"),
        meta: {
          title: "進銷存 - 庫存管理",
          minPermissionRequired: [
            "PURCHASE_FORM_READ",
            "ORDER_FORM_READ",
            "SALE_FORM_READ",
            "STOCK_CHECK_FORM_READ",
          ],
        },
      },
      {
        path: "/inventory/check",
        name: "InventoryCheck",
        component: () => import("../views/inventory/Check"),
        meta: {
          title: "進銷存 - 編輯庫存盤點單",
          minPermissionRequired: ["STOCK_CHECK_FORM_READ"],
        },
      },

      {
        subTab: "inventory",
        label: "服務",
        path: "/inventory/service",
        name: "InventoryService",
        component: () => import("../views/inventory/Service"),
        meta: {
          title: "進銷存 - 服務項目",
          minPermissionRequired: ["SERVICE_READ"],
        },
      },
      {
        subTab: "inventory",
        label: "統計",
        path: "/inventory/analysis",
        name: "InventoryAnalysis",
        component: () => import("../views/inventory/Analysis"),
        meta: {
          title: "進銷存 - 統計報表",
          minPermissionRequired: ["ERP_REPORTS"],
        },
      },
      {
        subTab: "inventory",
        label: "設定",
        path: "/inventory/setting",
        name: "InventorySetting",
        component: () => import("../views/inventory/Setting"),
        meta: {
          title: "進銷存 - 設定",
          minPermissionRequired: ["ERP_SETTINGS_READ"],
        },
      },
      {
        path: "/inventory/setting/device/:deviceID",
        name: "InventoryEditStandard",
        component: () => import("../views/inventory/DeviceStandard"),
        meta: {
          title: "進銷存 - 儀器標準值設定",
          minPermissionRequired: ["ERP_SETTINGS_READ"],
        },
      },
      {
        subTab: "purchasing",
        label: "總覽",
        path: "/purchasing/index",
        name: "PurchasingIndex",
        component: () => import("../views/purchasing/Index"),
        meta: {
          title: "採購專區 - 總覽",
          minPermissionRequired: [],
        },
      },
      {
        subTab: "reminder",
        label: "提醒",
        path: "/reminder/index",
        name: "ReminderIndex",
        component: () => import("../views/reminder/Index"),
        meta: {
          title: "提醒通知 - 提醒",
        },
      },
      {
        subTab: "bi",
        label: "BI報表",
        path: "/bi/index",
        name: "BiIndex",
        component: () => import("../views/bi/Index"),
        meta: {
          title: "BI報表 - BI報表",
        },
      },
      // {
      //   subTab: "reminder",
      //   label: "通知",
      //   path: "/reminder/notification",
      //   name: "ReminderNotification",
      //   component: () => import("../views/reminder/Notification"),
      //   meta: {
      //     title: "提醒通知 - 通知",
      //   },
      // },
      {
        subTab: "setting",
        label: "一般",
        path: "/setting/info",
        name: "SettingInfo",
        component: () => import("../views/setting/Info"),
        meta: {
          title: "診所設定 - 一般設定",
          //進入該頁面的最低權限需求，符合其一即可
          minPermissionRequired: ["GENERAL_SETTINGS_READ"],
        },
      },
      {
        subTab: "setting",
        label: "帳號",
        path: "/setting/staffs",
        name: "SettingStaffs",
        component: () => import("../views/setting/Staffs"),
        meta: {
          title: "診所設定 - 帳號管理",
          minPermissionRequired: ["ACCOUNT_READ", "ROLE"],
        },
      },
      {
        subTab: "setting",
        label: "營業時間",
        path: "/setting/booking",
        name: "SettingBooking",
        component: () => import("../views/setting/Booking"),
        meta: {
          title: "診所設定 - 預約設定",
          minPermissionRequired: ["BIZ_HOURS_READ"],
        },
      },
      {
        subTab: "setting",
        label: "醫師排班",
        path: "/setting/schedule",
        name: "SettingSchedule",
        component: () => import("../views/setting/Schedule"),
        meta: {
          title: "診所設定 - 醫師排班",
          minPermissionRequired: ["DOCTOR_ROASTER_READ"],
        },
      },
      {
        subTab: "setting",
        label: "自訂表單",
        path: "/setting/customizeForm",
        name: "CustomizeForm",
        component: () => import("../views/setting/CustomizeForm"),
        meta: {
          title: "設定 - 自訂表單",
          minPermissionRequired: ["CUSTOMIZE_FORM"],
        },
      },
      {
        subTab: "setting",
        label: "系統功能",
        path: "/setting/system",
        name: "System",
        childRoutes: ["SystemTreatment"],
        component: () => import("../views/setting/System"),
        meta: {
          title: "設定 - 系統功能",
          minPermissionRequired: ["NXVET_SYSTEM"],
        },
      },
      {
        path: "/setting/system/treatment",
        name: "SystemTreatment",
        component: () => import("../views/setting/SystemTreatmentManage"),
        meta: {
          minPermissionRequired: ["NXVET_SYSTEM"],
        },
      },
      {
        subTab: "setting",
        label: "方案",
        path: "/setting/package",
        name: "SettingPackage",
        // beforeEnter: (to, from, next) => {
        //   if (store.state.user.user.permission === "admin") {
        //     next();
        //   } else {
        //     next("/");
        //   }
        // },
        component: () => import("../views/setting/Package"),
        meta: {
          title: "診所設定 - 方案",
          minPermissionRequired: ["NXVET_PLANS"],
        },
      },
      {
        subTab: "setting",
        label: "同步工具",
        path: "/setting/synctool",
        name: "SyncTool",
        component: () => import("../views/setting/SyncTool"),
        meta: {
          title: "診所設定 - 同步工具",
          minPermissionRequired: ["NXVET_SYNCTOOL"],
        },
      },
      {
        path: "/permissionDeny",
        name: "PermissionDeny",
        component: () => import("../views/PermissionDeny"),
        meta: {
          title: "權限不足",
        },
      },
    ],
  },
  // {
  //   path: "/",
  //   beforeEnter: isLogin,
  //   component: () => import("@/components/layouts/Payment"),
  //   children: [
  //     {
  //       path: "/payment/:pid/complete",
  //       name: "PaymentComplete",
  //       component: () => import("../views/payment/Complete"),
  //       meta: { title: "付款 - 結果頁" },
  //     },
  //   ],
  // },
  // {
  //   path: "/payment/checkout",
  //   beforeEnter: isLogin,
  //   name: "PaymentCheckout",
  //   component: () => import("../views/payment/Checkout"),
  //   meta: { title: "付款 - 結帳頁" },
  // },
  {
    path: "/uploadFile",
    name: "UploadFileByPhone",
    component: () => import("../views/UploadFileByPhone"),
    meta: { title: "檔案上傳頁" },
  },
  {
    path: "/printExam",
    name: "PrintExam",
    component: () => import("../views/PrintExam"),
    meta: { title: "檢驗列印頁" },
  },
  {
    path: "/linepayDone",
    name: "LinepayDone",
    component: () => import("../views/linepay/LinepayDone"),
    meta: { title: "LinePay付款結果" },
  },
  // {
  //   path: "/schedule/overview",
  //   component: () => import("@/views/NewPage.vue"),
  //   alias: ["/schedule/waiting", "/schedule/todo", "/schedule/checkout"],
  // },
  {
    name: "googleAuth",
    path: "/googleAuth",
    component: () => import("@/views/googleAuth.vue"),
  },
  {
    name: "404",
    path: "/404",
    component: () => import("@/views/notFound.vue"),
  },
  {
    path: "*",
    redirect: "/404",
  },
];

export default routes;
